(function () {
  'use strict';

  // The header cart bubble is Liquid, rendered once at page load (sections/header.liquid), and the
  // Kaktus drawer calls Shopify's cart API from its own iframe without telling the header — so a
  // line removed there leaves a stale count until a reload. Watch the drawer and re-render the
  // bubble from the cart-icon-bubble section, keeping the pluralisation and a11y text in Liquid.

  var DEBOUNCE_MS = 400;
  var SCAN_MS = 1000;
  var LINES = '.kaktusc-cart__products';

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function docs() {
    var out = [];
    function add(w) {
      if (!w) return;
      var d;
      try { d = w.document; } catch (e) { return; }
      if (!d || out.indexOf(d) !== -1) return;
      out.push(d);
      var frames;
      try { frames = w.frames; } catch (e) { frames = null; }
      if (!frames) return;
      for (var i = 0; i < frames.length; i++) {
        try { add(frames[i]); } catch (e) {}
      }
    }
    var root = window;
    try { root = window.top || window; } catch (e) { root = window; }
    add(root);
    add(window);
    return out;
  }

  function lineContainers() {
    var out = [];
    docs().forEach(function (d) {
      try {
        d.querySelectorAll(LINES).forEach(function (n) { out.push(n); });
      } catch (e) {}
    });
    return out;
  }

  // Swap only the bubble, so a custom cart icon set in the header settings survives.
  function applyBubble(html) {
    var link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('.cart-count-bubble');
    var current = link.querySelector('.cart-count-bubble');
    if (!fresh) {
      if (current) current.parentNode.removeChild(current);
      return;
    }
    var node = document.importNode(fresh, true);
    if (current) current.parentNode.replaceChild(node, current);
    else link.appendChild(node);
  }

  var inFlight = false;
  var pending = false;
  function refresh() {
    if (inFlight) { pending = true; return; }
    inFlight = true;
    fetch(cartUrl() + '?section_id=cart-icon-bubble', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(applyBubble)
      .catch(function () {})
      .then(function () {
        inFlight = false;
        if (pending) { pending = false; schedule(); }
      });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, DEBOUNCE_MS);
  }

  // The line list only — the drawer header runs a "cart will expire in mm:ss" countdown, so
  // observing the whole document would refetch once a second.
  function observe(container) {
    if (container.__bsubCountObserved) return;
    container.__bsubCountObserved = true;
    var view = container.ownerDocument.defaultView;
    if (!view || !view.MutationObserver) return;
    new view.MutationObserver(schedule).observe(container, { childList: true, subtree: true });
  }

  var wasOpen = false;
  function scan() {
    var containers = lineContainers();
    containers.forEach(observe);
    var isOpen = containers.length > 0;
    // Catches what the observer can't: the drawer unmounting itself on the last line removed.
    if (wasOpen && !isOpen) schedule();
    wasOpen = isOpen;
  }

  ['cart:refresh', 'cart:updated', 'pageshow'].forEach(function (name) {
    window.addEventListener(name, schedule);
  });

  window.__bsubCartCount = 'loaded';
  setInterval(scan, SCAN_MS);
  scan();
})();
